import React from 'react'
import { FileDown } from 'lucide-react'

// Documento con flecha de descarga (solicitar documentación / exportar). Ignora las props de
// SvgIcon que aún le pasan algunos consumidores (htmlColor, fontSize) para que no lleguen al <svg>.
// eslint-disable-next-line no-unused-vars
const icon = ({ htmlColor, fontSize, ...props }) => (
  <FileDown size={fontSize === 'large' ? 24 : 18} color={htmlColor || 'currentColor'} {...props} />
)

export default icon
